import { render, staticRenderFns } from "./TasksPage.vue?vue&type=template&id=455cc6d8"
import script from "./TasksPage.vue?vue&type=script&lang=js"
export * from "./TasksPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports